import React from "react";
import { Link } from "react-router-dom";
import { Biohazard, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DailyFact } from "./DailyFact";

export const HomeView = React.memo(() => {
  const { t } = useTranslation('HomeView');
  return (
    <div className="flex flex-col items-center justify-center pt-12 pb-24 text-center px-4 relative z-10">
      <div className="animate-bounce mb-8">
        <Biohazard
          size={100}
          className="text-skjeta-green drop-shadow-[0_0_25px_rgba(163,230,53,0.6)] animate-pulse-fast"
        />
      </div>
      <h1 className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-skjeta-green via-white to-skjeta-purple mb-6 tracking-tighter italic drop-shadow-2xl">
        SKJETA.NO
      </h1>
      <p className="text-xl text-gray-300 max-w-lg mb-12 font-light">
        {t('welcomeIntro')}{" "}
        <span className="text-skjeta-purple font-bold italic">{t('sykeste')}</span>{" "}
        {t('welcomeOutro')}
        <br />
        {t('tagline')}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-2xl">
        <Link
          to="/memes"
          className="bg-skjeta-green text-black p-8 rounded-2xl font-black text-2xl hover:scale-105 transition-transform shadow-[0_0_30px_rgba(163,230,53,0.3)] group relative overflow-hidden focus:outline-none focus:ring-4 focus:ring-white flex items-center justify-center"
        >
          <span className="relative z-10 flex items-center justify-center gap-2">
            {t('seeMemes')} <Zap className="fill-black" />
          </span>
          <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></div>
        </Link>
        <Link
          to="/games"
          className="bg-skjeta-purple text-white p-8 rounded-2xl font-black text-2xl hover:scale-105 transition-transform shadow-[0_0_30px_rgba(217,70,239,0.3)] group relative overflow-hidden focus:outline-none focus:ring-4 focus:ring-white flex items-center justify-center"
        >
          <span className="relative z-10">{t('playNow')}</span>
          <div className="absolute inset-0 bg-black/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></div>
        </Link>
      </div>

      <div className="mt-16 w-full max-w-lg">
        <DailyFact />
      </div>
    </div>
  );
});
